import { ChangeDetectionStrategy, Component, ChangeDetectorRef,OnInit, ViewEncapsulation, Inject, ElementRef, SimpleChanges } from '@angular/core';
import { OneBreadcrumb } from '@one/angular-kit/navigation';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { AppUtils } from '../../../../shared/utilities/app-utils';
import { ViewReminderDetailsComponent } from '../view-reminder-details/view-reminder-details.component';
import { MatDialog } from '@angular/material/dialog';
import { LsoAcknowledgementComponent } from '../lso-acknowledgement/lso-acknowledgement.component';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NotificationAuditTrailComponent } from '../notification-audit-trail/notification-audit-trail.component';

@Component({
  selector: 'dl-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactDetailsComponent implements OnInit {
  public breadcrumbs: OneBreadcrumb[];
  customerDataObj: any;
  Status:any;
  public testdata: any[];
  CustomerId: any;
  customerTitle: any;
  isEditDisabled: boolean = false;
  isReminderDisabled: boolean = true;
  showEditControls: boolean = false;
  isResendEnabled:boolean = false;
  public customerData:any;
  public customerNotificationData: any;
  public recepientForm: FormGroup;
  public CustomerDetails:any;
  public NotificationId:any;
  public userFileSize = { size: 0, type: '' };
  public userPermission: any;
  public allReminderSent: any;
  public ackFile: any = [];
  public ackComment: any;
  public ackFileName: any;
  public ackFileSize: any;
  public isSetCom: boolean = false;
  public isNotiStat: boolean =false;
  public contactNotificationId: any;
  public accDataObj: any;
  public isDisabled: boolean =false;

  
  constructor(
    public appUtils: AppUtils,
    private fb: FormBuilder,
    private _cdr: ChangeDetectorRef,
    private router: Router,
    private readonly oneSnackBar: OneSnackBarService,
    private qnsbnservice :QnSbnService,
    private readonly dialog: MatDialog,
    public _QnSbnService:QnSbnService,
    public _QnSbnDataService:QnSbnDataService,
  ) {}

  public sort: MatSort;
  exporter: ElementRef<any>;
  notificationDetails: any;
  selectedRecepientColumns: any;
  contactDetails: any;
  notificationLabel: any;
  contactDataDetails: any;
  public displayedColumns: string[];
  public dataSource: MatTableDataSource<any>;
  public selection: SelectionModel<any>;
  public selectedRow: any;
  public isAddRecipientDisabled: boolean;
  public isAfoBtnDisabled: boolean;
  public isAfoBtnExpanded: boolean;
  public filteredStatusList: any;
  public auditTrailDatafromAPI: any;
  public notificationId: any;

  public ngOnChanges(changes: SimpleChanges): void {
    throw new Error('Method not implemented.');
  }
  public isAllSelected($event: any): boolean {
    throw new Error('Method not implemented.');
  }
  public masterToggle($event: any): void {
    throw new Error('Method not implemented.');
  }
  public handleChecked(row: any): void {
    throw new Error('Method not implemented.');
  }
  public ndAddRecepients(): void {
    throw new Error('Method not implemented.');
  }
  
  public ngOnInit(): void {
    this.userPermission = this.qnsbnservice.getUserData();
    this.customerDataObj = history.state;
    this.accDataObj =  this.customerDataObj.accDataObj
    this.customerData = this.customerDataObj.customerDetails.customerData;
    this.isSetCom = this.customerDataObj.customerDetails.isSetCom;
    this.isNotiStat = this.customerDataObj.customerDetails.notificationStatus;
    this.customerNotificationData = this.customerDataObj.customerDetails.notificationData[0];
    this.NotificationId = this.customerData.NotificationId;
    this.contactNotificationId = this.customerData.ContactNotificationId
    this.CustomerId = this.customerData.CustomerId;
    this.customerTitle = this.customerData.CustomerContactName;
    this.allReminderSent = this.getAllReminderSent(this.customerData.CustomerReminderDetails);
    this.breadcrumbs = [
      {
        label: 'Notifications'
      },
      {
        label: this.customerData.LocalId
      },
      {
        label: this.customerData.CustomerName + " " + this.customerData.CustomerId
      },
      {
        label: this.customerTitle
      }
    ];
    if (this.customerData.Status === "Completed" || this.customerData.Status === "Feedback Received") {
      this.isEditDisabled = true;
    }
    if (this.customerData.Status !== "Feedback Received" && this.customerData.Status !== "Completed") {
      this.isResendEnabled = true;
    }
    if (this.customerData.Status === "Delivery Failed") {
      this.isDisabled = true;
    }
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ .]{2,30}$/;
    const sourceRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ ._\-&0-9,']{2,30}$/;
    this.recepientForm = this.fb.group({
      recepientSource: [null, [Validators.required, Validators.pattern(sourceRegex)]],
      // recepientName: [null, [Validators.required, Validators.pattern(nameRegex)]],
      recepientName: [null, [Validators.required]],
      recepientEmail: [null, [Validators.required, Validators.pattern(emailRegex)]], // Validators.email
    });
    if(this.customerData.CustomerAttachment){
      this.ackComment = this.customerData.CustomerAttachment.Comments;
      this.ackFileName = this.customerData.CustomerAttachment.Filename;
      this.ackFileSize = this.customerData.CustomerAttachment.FileSize;
    }else{
      this.ackComment = '';
      this.ackFileName = '';
      this.ackFileSize = '';
    } 
}

  editRecepientDetails() {
    this.CustomerDetails = {
      "ContactNotificationId":this.customerData.ContactNotificationId,
      "CustomerContactEmail":this.recepientForm.value.recepientEmail,
      "NotificationId": this.customerData.NotificationId,
      "CustomerId": this.customerData.CustomerId,
      "CustomerName": this.customerData.CustomerName,
      "DataSource":this.recepientForm.value.recepientSource,
      "CustomerContactName": this.recepientForm.value.recepientName
    };

    this.qnsbnservice.EditCustomerData(this.CustomerDetails).subscribe(
      (response: HttpResponse<any>) => {
        this.customerData.DataSource = this.recepientForm.value.recepientSource;
        this.customerData.CustomerContactName = this.recepientForm.value.recepientName;
        this.customerData.CustomerContactEmail = this.recepientForm.value.recepientEmail;
        this.closeEditForm();
        this._cdr.detectChanges();
        this.oneSnackBar.open('Contact data updated Successfully', OneSnackBarType.SUCCESS, '', { duration: 5000 });
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Contact data updation Failed.');
        //this.oneSnackBar.open('CustomerData Edited Failed.', OneSnackBarType.ERROR, '', { duration: 5000 });
        //console.log('error:',error);
      }
    );
    
  }
  openEditForm() {
    this.showEditControls = true;
    this.recepientForm.controls['recepientSource'].setValue(this.customerData.DataSource);
    this.recepientForm.controls['recepientName'].setValue(this.customerData.CustomerContactName);
    this.recepientForm.controls['recepientEmail'].setValue(this.customerData.CustomerContactEmail);
  }
  closeEditForm() {
    this.showEditControls = false;
  }

  public viewReminders(): void {
    const dialogRef = this.dialog.open(ViewReminderDetailsComponent , {
      data: { notificationData: this.customerNotificationData, customerData: this.customerData},
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // this.fileData = result.fileData;
      // console.log(result);
    });
  }

  public bytesCalculation(bytes: number, decimals: number = 2): any {
    if (bytes === 0) {
      this.userFileSize.size = 0;
      this.userFileSize.type = '';
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    this.userFileSize.size = 0;
    this.userFileSize.type = '';

    this.userFileSize.size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    this.userFileSize.type = sizes[i];
    return this.userFileSize;
  }

  public formatBytes(bytes: number, decimals: number = 2): string {
    this.bytesCalculation(bytes, decimals);
    return this.userFileSize.size + ' ' + this.userFileSize.type;
  }

  public getAllReminderSent(reminderDetails: any) {
    // [{ReminderSendStatus: "Not Sent", ReminderDueDate: "02-Feb-2022", ReminderId: 0}]
    const reminderSents = [];
    if (reminderDetails && reminderDetails.length > 0) {
      reminderDetails.forEach(reminder => {
        if (reminder.ReminderSendStatus === 'Delivered') {
          let reminderSentDate = reminder.ReminderSendDate ? reminder.ReminderSendDate : reminder.ReminderDeliveryFailedDate ? reminder.ReminderDeliveryFailedDate : reminder.ReminderDueDate;
          reminderSents.push(this.appUtils.formatDateWithTime(reminderSentDate));
        }
      });
    } else {
      reminderSents.push('');
    }
    return reminderSents;
  }

  public displayStatus(status) {
    const statusText = status ? status : 'Pending';
    return statusText;
  }

  public downloadDocument(globalNotificationId: string, fileExtension: string) {
    this.qnsbnservice.downloadPiosDocumentApi(globalNotificationId, fileExtension);
  }
  
  public downloadAttachment(fileName: string, notificationId: string) {
    this.qnsbnservice.downloadLocalAttachmentApi(fileName, notificationId);
  }
  
  public downloadLSOAttachment(fileName: string, notificationId: string, contactNotificationId: string) {
    this.qnsbnservice.downloadLSOAttachmentApi(fileName, notificationId, contactNotificationId);
  }

  public onResendNotification(){
    const resendApi = {
      NotificationId : this.NotificationId,
      ContactNotificationIds:  [this.customerData.ContactNotificationId]
    }
    const resendJson= JSON.stringify(resendApi);
    this.qnsbnservice.postResendNotifications(resendJson).subscribe(
      (data:any) => {
        this.oneSnackBar.open('Notification sent successfully', OneSnackBarType.SUCCESS, '', { duration: 5000 });
        this.gotoAccountDetailsPage();
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Email id is either not verified or wrong. Please correct and try again later.');
      }
    );
  }

  public downloadEmailEvidence(filename: string) {
    let  notificationId: string = this.customerData.NotificationId;
    let CustomerContactEmail: string = this.customerData.CustomerContactEmail;
    this.qnsbnservice.downloadEmailEvidenceApi(notificationId, filename, CustomerContactEmail);
  }

  public lsoAcknowledgement(): void {
    const dialogRef = this.dialog.open(LsoAcknowledgementComponent, {
      disableClose: true,
      panelClass: 'ack-dialog'
    });
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.ackComment = res.ackComment
      this.ackFile = res.ackFile;
      this.ackFileApiCall(this.ackFile);
    });
  }

  public ackFileApiCall(fileData): void {
    if(fileData.length > 0){
      for(let f=0;f<=(fileData.length-1);f++){
        if(fileData[f].uploadFile) {
          const feedbackApi = {
            customerId: this.customerData.CustomerId,
            email: this.customerData.CustomerContactEmail,
            notificationId: this.customerData.NotificationId,
            comments: this.ackComment,
            fileName: fileData[f].name,
            fileSize: this.formatBytes(fileData[f].size),
            contactNotificationId: this.customerData.ContactNotificationId
          }
          const feedbackApiJson = JSON.stringify(feedbackApi);
          this._QnSbnService.fileAckSaveOnS3(fileData[f], this.customerData.ContactNotificationId,this.customerData.NotificationId).subscribe((res) =>{
            this._QnSbnService.feedbackApi(feedbackApiJson).subscribe((res) => {
              this.gotoNotificationDetailsPage();
              this.oneSnackBar.open(`Acknowledgement successfully created`, OneSnackBarType.SUCCESS, '', { duration: 5000 });
            },
            (err)=>{
              this.oneSnackBar.open(`Please try again later`, OneSnackBarType.ERROR, '', { duration: 5000 });
            });
          });
        }
      }       
    }else{
      const feedbackApi = {
        customerId: this.customerData.CustomerId,
        email: this.customerData.CustomerContactEmail,
        notificationId: this.customerData.NotificationId,
        comments: this.ackComment,
        contactNotificationId: this.customerData.ContactNotificationId
      }
      const feedbackApiJson = JSON.stringify(feedbackApi);
      this._QnSbnService.feedbackApi(feedbackApiJson).subscribe((res) => {
        this.gotoNotificationDetailsPage();
        this.oneSnackBar.open(`Acknowledgement successfully created`, OneSnackBarType.SUCCESS, '', { duration: 5000 });
      },
      (err)=>{
        this.oneSnackBar.open(`Please try again later`, OneSnackBarType.ERROR, '', { duration: 5000 });
      });
    }
  }

  public gotoAccountDetailsPage() {
    let rowData = {
      customerData: this.accDataObj,
      isSetCom: this.isSetCom,
      notificationStatus:  this.isNotiStat,
      notificationData: this.customerNotificationData
    };
    this.qnsbnservice.getContactList(this.accDataObj.AccountNotificationId).subscribe(
      res =>{
        this.router.navigateByUrl('/account-details', { state: { customerDetails: rowData, notificationDataObj: res.body } });
      },
      err =>{
        this.oneSnackBar.open('Failed to fetch Contact Data', OneSnackBarType.ERROR, '', { duration: 5000 });
      }
    );
  }

  public gotoNotificationDetailsPage(){
    this.qnsbnservice.getNotificationContactDetails(this.NotificationId).subscribe(
      (data:any) => {
        this._QnSbnService.getAccountList(this.NotificationId).subscribe(
          res =>{
            this.router.navigateByUrl('/notification-details', { state: { notificationData: this.customerNotificationData, contactData: data, accountDataObj: res.body } });
          },
          (err: HttpErrorResponse) => {
            this._QnSbnService.httpErrorHandler(err, 'Could not fetch Account Data');
          }
        );
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Could not fetch contact details.');
        this.router.navigateByUrl('/notification-details', { state: { notificationData: this.customerNotificationData, contactData: [], accountDataObj: [] } });
      }
    );
  }

  public gotoNotificationPage(){
    this.router.navigateByUrl('/notification');
  }

  public viewAuditTrail(){
    
    this.contactNotificationId = this.customerData.ContactNotificationId;
    this.qnsbnservice.getContactNotificationAuditTrailList(this.contactNotificationId).subscribe(
      res =>{
        this.auditTrailDatafromAPI=res;
  
        this.dialog.open(NotificationAuditTrailComponent,{
              data:{
                tableData: this.auditTrailDatafromAPI
              },
              disableClose: true,
              panelClass: 'AuditTrailPopUp'
            });
      },
      err =>{
        this.oneSnackBar.open('Failed to fetch Audit Trail Data', OneSnackBarType.ERROR, '', { duration: 5000 });
      }
    );
  }
}